export default __webpack_public_path__ + "static/media/phoenix-min.3ffb6e4c.png";